import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vex-create-report',
  templateUrl: './create-report.component.html',
  styleUrls: ['./create-report.component.scss']
})
export class CreateReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
